export default {
  startingLineups: {
    title: "Startaufstellungen",
    labels: {
      confirmed: "BESTÄTIGT",
      expected: "ERWARTET",
      tbd: "OFFEN",
      noLineupAvailable: "Keine Aufstellung verfügbar",
    },
    empty: {
      title: "Keine Aufstellungen verfügbar",
    },
  },
};
